import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../../lib/api';
import type { LoadNotification } from './types';

export * from './types';
export * from './history';

const loadNotificationsKey = (itemId: string | null | undefined) => [
  'org:orders:item',
  itemId,
  'notifications',
];

/** Every customer email sent about one load, newest first. */
export function useLoadNotifications(
  itemId: string | null | undefined,
  enabled = true,
  pollEveryMs?: number
) {
  return useQuery<{ notifications: LoadNotification[] }>({
    queryKey: loadNotificationsKey(itemId),
    queryFn: async () => (await api.get(`/organization/order-items/${itemId}/notifications`)).data,
    enabled: Boolean(itemId) && enabled,
    refetchInterval: pollEveryMs || false,
  });
}

export function useResendLoadNotification(itemId: string) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (logId: string) => {
      const { data } = await api.post(
        `/organization/order-items/${itemId}/notifications/${logId}/resend`
      );
      return data;
    },
    onSuccess: () => {
      // A resend writes its own log row, so the history and the stamp both move.
      qc.invalidateQueries({ queryKey: loadNotificationsKey(itemId) });
      qc.invalidateQueries({ queryKey: ['auditLogs'] });
    },
  });
}
